import { VerticalAlignment } from "@mcleod/core";
import { ComponentTypes } from "../../base/ComponentTypes";
import { DesignerToolsTableCellStyles } from "./DesignerToolsTableCellStyles";
import { Label } from "../label/Label";
import { PropsAccessLabelCreator } from "../../PropsAccessLabelCreator";
import { TableCell } from "./TableCell";
import { TableCellProps } from "./TableCellProps";

enum InnerIds {
    ROW_PROPS_ACCESS_LABEL = "rowPropsAccessLabel"
}

export class DesignerToolsTableCell extends TableCell {
    static readonly FIXED_WIDTH = "40";
    private rowPropsAccessLabel: Label;
    
    constructor(props?: Partial<TableCellProps>) {
        const propsToUse = {
            ...props,
            fixedWidth: DesignerToolsTableCell.FIXED_WIDTH,
            id: `${props.table.id}-${props.row.index}-designerToolsCell`,
            paddingLeft: 2,
            paddingRight: 2,
            verticalAlign: VerticalAlignment.CENTER
        };
        super(propsToUse);
        this.allowDropInDesigner = false;

        this.createRowPropsAccessLabel();
        this.add(this.rowPropsAccessLabel);
    }

    protected override addDefaultClassName() {
        this.element.classList.add(DesignerToolsTableCellStyles.base);
    }

    private createRowPropsAccessLabel() {
        this.rowPropsAccessLabel = PropsAccessLabelCreator.create({
            _designer: this.table._designer,
            fontSize: 8,
            id: this.createInnerComponentId(InnerIds.ROW_PROPS_ACCESS_LABEL),
            margin: 0,
            tooltipDynamicDesignerContent: "Click to access the properties for the table row",
            verticalAlign: VerticalAlignment.CENTER,
            width: 36,
            wrap: false
        });
        this.rowPropsAccessLabel.alternateDesignerTarget = this.row;
    }

    public override get selectableInDesigner(): boolean {
        return false;
    }

    override isSerialized(): boolean {
        return false;
    }
}
ComponentTypes.registerComponentType("designertoolscell", {
    constructor: DesignerToolsTableCell.prototype.constructor
});
